<template>
  <div
    class="addVideoButton"
    @click="filePicker"
  >
    <div class="icon">
      <iconfont
        class="normal"
        name="#icon13-3tianjiashipin"
      ></iconfont>
      <iconfont
        class="hover"
        name="#icon13-3tianjiashipinjiaohu"
      ></iconfont>
    </div>
    <div>添加视频</div>
  </div>
</template>

<script>
export default {
  name: 'AddVideoButton',
  components: {},
  props: {
    uploadBtnTip: String
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {
    this.$bus.on('changeFiles', this.changeFile);
  },
  mounted() {
    let shot = this.$store.getters['uploader/videoUrlShot'];
    if (shot.url && !(this.$route.query || {}).id && !(this.$route.query || {}).pipe) {
      this.changeFile(shot);
    }
  },
  beforeDestroy() {
    this.$bus.off('changeFiles', this.changeFile);
  },
  methods: {
    changeFile(data) {
      this.$emit('fromWeb', [
        {
          name: data.name || '',
          duration: data.duration || data.during,
          cover: data.cover || data.screen || data.thumbnailUrl,
          url: data.url,
          size: data.size,
          source: data.fileType == 26 ? '视频库' : '作品库'
        }
      ]);
    },
    filePicker() {
      this.$modal.show('selectModal', {
        isUpload: false,
        clickOnly: true,
        uploadBtnTip: this.uploadBtnTip,
        onClickUpload: () => {
          var input = document.createElement('input');
          input.setAttribute('multiple', 'multiple');
          input.setAttribute('type', 'file');
          input.setAttribute('accept', '.MP4, .MOV, .AVI, .WMV, .FLV, .QLV, .QSV, .KUX');
          input.onchange = (e) => {
            this.$modal.hide('selectModal');
            this.$emit('fromLocal', e.currentTarget.files);
          };
          input.click();
        },
        onInfo: (info) => {
          this.$modal.hide('selectModal');
          if (info && !Array.isArray(info)) {
            info = [info];
          }
          let list = [];
          for (let i = 0; i < info.length; i++) {
            let data = info[i];
            if (!data.url) continue;

            let cover = '';
            if (data.screen) {
              cover = data.screen;
            } else if (data.thumbnailUrl) {
              let str = `${data.thumbnailUrl},`;
              str = str.match(/(\S*),/);
              if (str.length > 1) {
                cover = str[1];
              }
            }
            list.push({
              name: data.title || '',
              duration: data.duration || data.during,
              cover: cover,
              url: data.url,
              size: data.size,
              source: data.fileType == 26 ? '视频库' : '作品库'
            });
          }
          this.$emit('fromWeb', list);
        } // 点击我的作品打卡列表弹窗，选一个作品然后点击确定时回调
      });
    }
  }
};
</script>

<style scoped lang="scss">
.addVideoButton {
  color: #3e424c;
  display: flex;
  align-items: center;
  cursor: pointer;

  .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 8px;
    border-radius: 50%;
    background: #ffffff;
    border: 1px solid #ffffff;
    box-shadow: 1px 2px 5px 0px rgba(124, 124, 124, 0.13);

    .hover {
      display: none;
    }
  }
  &:hover {
    .normal {
      display: none;
    }
    .hover {
      display: block;
    }
  }
}
@media screen and (max-width: 1600px) {
  .addVideoButton {
    font-size: 12px;
    .icon {
      width: 26px;
      height: 26px;
      font-size: 10px;
    }
  }
}
@media screen and (min-width: 1600px) {
  .addVideoButton {
    font-size: 14px;
    .icon {
      width: 30px;
      height: 30px;
      font-size: 12px;
    }
  }
}
</style>
